import { getAuthToken } from "auth/authToken";
import { MainContent } from "components/Layout/components/Content";
import { Header, HeaderProps } from "components/Layout/components/Header/Header";
import { MasterLayout } from "components/Layout/components/MasterLayout";
import { SideBar } from "components/Layout/components/SideBar";
import { SupportedApps } from "config/config";
import { useApp } from "hooks/useApp";
import { useEnsureAuthenticated } from "hooks/useEnsureAuthenticated";
import React from "react";

const Menu = React.lazy(() => import("dmsapp/Menu"));
const EnvironmentProvider = React.lazy(() => import("dmsapp/EnvironmentProvider"));
const AppRouter = React.lazy(() => import("dmsapp/AppRouter"));

type DmsContainerType = {
    headerProps: HeaderProps;
    unauthenticatedHandler: (back: string) => void;
};

export const DmsContainer = ({ headerProps, unauthenticatedHandler }: DmsContainerType) => {
    const ensureAuthenticated = useEnsureAuthenticated();
    const authToken = getAuthToken();
    const hasRole = (_role: string) => {
        return true;
    };

    const dmsApp = useApp(SupportedApps.dms);

    return (
        dmsApp.isLoaded() !== undefined && (
            <EnvironmentProvider
                authToken={authToken}
                containerVersion={APP_INFO.VERSION}
                configuration={dmsApp.configuration}
                ensureAuthenticated={ensureAuthenticated}
                hasRole={hasRole}
                unauthenticatedHandler={unauthenticatedHandler}
            >
                <MasterLayout>
                    <Header appTitle={headerProps.appTitle} username={headerProps.username} userProfile={headerProps.userProfile} />
                    <SideBar>
                        <Menu />
                    </SideBar>
                    <MainContent id="pageContent">
                        <AppRouter />
                    </MainContent>
                </MasterLayout>
            </EnvironmentProvider>
        )
    );
};
